import nextApi from "./next-api";

const getCourseStructure = (id) => {
  return nextApi.get(`cms/course-structure?programId=${id}`);
};

const addCourseStructure = (data) => {
  console.log(data);
  return nextApi.post(`cms/course-structure`, data);
};

const updateCourseStructure = (id, data) => {
  console.log(data);
  return nextApi.put(`cms/course-structure?id=${id}`, data);
};

const deleteCourseStructure = (id) => {
  return nextApi.delete(`cms/course-structure?id=${id}`);
};

const CourseStructureService = {
  getCourseStructure,
  addCourseStructure,
  updateCourseStructure,
  deleteCourseStructure,
};

export default CourseStructureService;
